module.exports = __webpack_public_path__ + "static/img/5767_phase_function_Paper_PointsHejduk_Prediction.fea436a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5767_phase_function_Paper_PointsHejduk_Prediction.png
// module id = L6Jf
// module chunks = 0